<template>
  <div class="container">
    <div class="inner-box">
      <p class="title">
        <span>{{leftList.name}}</span>
        <span @click="toList(leftList.id)">更多</span>
      </p>
      <ul class="list-wrapper">
        <li class="list-item" v-for="item in (leftList.content || '').slice(0, 10)" :key="item.id">
          <span :class="showNew(item.check_time)" @click="toDetail(item.id)"><strong style="font-size: 10px">· </strong>{{item.title | titleFilter}}</span>
          <span class="article-time">{{item.check_time}}</span>
        </li>
      </ul>
    </div>
    <div class="inner-box">
      <p class="title">
        <span>{{middleList.name}}</span>
        <span @click="toList(middleList.id)">更多</span>
      </p>
      <ul class="list-wrapper">
        <li class="list-item" v-for="item in (middleList.content || '').slice(0, 10)" :key="item.id">
          <span :class="showNew(item.check_time)" @click="toDetail(item.id)"><strong style="font-size: 10px">· </strong>{{item.title | titleFilter}}</span>
          <span class="article-time">{{item.check_time}}</span>
        </li>
      </ul>
    </div>
    <div class="theme-wrapper">
      <p class="theme-title">
        专题专栏
      </p>
      <div class="theme-list">
        <a
          v-for="item in themeList"
          :key="item.id"
        >
          <img
            :src="item.image"
            class="theme-img"
            @click="toList(item.id.substring(0, item.id.length - 1))"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Chengdu',
  props: {
    chengdu: {
      type: Object,
      reuired: true
    }
  },
  filters: {
    titleFilter (title) {
      return title.replace(/<br \/>/, '')
    }
  },
  watch: {
    chengdu: function (data) {
      if (!data) {
        return
      }
      this.leftList = data.leftList[0]
      this.middleList = data.middleList[0]
      if (data.themeList && data.themeList.length > 0) {
        let size = 0
        if (data.themeList.length === 1) {
          const images = data.themeList[0].image.split(',')
          images.forEach((item, index) => {
            if (size <= 3) {
              this.themeList.push({
                id: data.themeList[0].id + (index + ''),
                image: item,
                pid: data.themeList[0].pid
              })
              size++
            }
          })
        } else {
          const themes = data.themeList
          themes.forEach((item, index) => {
            if (index < 1) {
              this.themeList.push({
                id: item.id + (index + ''),
                image: item.image,
                pid: item.pid
              })
              // console.log(this.themeList)
              size++
            } else {
              const images = item.image.split(',')
              images.forEach((item1, index1) => {
                if (size <= 3) {
                  this.themeList.push({
                    id: item.id + (index1 + ''),
                    image: item1,
                    pid: item.pid
                  })
                  size++
                }
              })
            }
          })
        }
      }
    }
  },
  data () {
    return {
      leftList: [],
      middleList: [],
      themeList: []
    }
  },
  methods: {
    showNew (time) {
      const str = time.replace(/-/g, '/')
      const createTime = new Date(str)
      const date = new Date()
      // 三天内
      if (createTime.getTime() <= date.getTime() && date.getTime() <= (createTime.getTime() + 259200000)) {
        return 'article-title new'
      }
      return 'article-title'
    },
    toList (id) {
      this.$router.push(`/news/${id}`)
    },
    toDetail (id) {
      this.$router.push(`/content/${id}`)
    }
  }
}
</script>

<style scoped>

@keyframes text {
  0%{
    color: red;
  }
  50%{
    color: pink;
  }
  100%{
    color: red;
  }
}
  .container {
    width: 1180px;
    height: 372px;
    display: flex;
    justify-content: space-between;
  }

  .inner-box {
    width: 32%;
    height: 100%;
    box-shadow: 1px 1px 4px #ccc;
    border: 1px solid #ccc;
    overflow: hidden;
  }

  .inner-box .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 40px;
    padding: 0 8px;
    border-bottom: 1px solid #cccccc;
  }

  .inner-box .title span:first-child {
    box-sizing: border-box;
    font-weight: 700;
    color: rgb(1, 142, 214);
    font-size: 18px;
  }

  .inner-box .title span:last-child {
    font-size: 12px;
    color: #cccccc;
  }

  .inner-box .title span:last-child:hover {
    text-decoration: underline;
    cursor: pointer;
  }

  .theme-wrapper {
    width: 390px;
    height: 374px;
    border: 1px solid #ccc;
    box-sizing: border-box;
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    box-shadow: 1px 1px 4px #ccc;
  }

  .theme-title{
    height: 40px;
    border-bottom: 1px solid #ccc;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 700;
    color: rgb(1, 142, 214);
  }

  .list-item {
    padding: 10px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .theme-list {
    flex: 1;
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
  }

  .theme-img {
    width: 348px;
    height: 65px;
  }

  .article-title {
    /*width: 60%;*/
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
  }

  .new{
    position: relative;
    padding-right: 40px;
    box-sizing: border-box;
  }

  .new:after{
    content: 'New';
    position: absolute;
    color: #333333;
    font-size: 10px;
    right: 0;
    padding: 3px 5px;
    border-radius: 3px;
    margin-left: 3px;
    animation: text 2s;
    animation-iteration-count: infinite;
  }

  .list-item:hover {
    color: rgb(1, 142, 214);
    cursor: pointer;
  }

  .article-time {
    flex-shrink: 0;
    color: #888888;
    font-size: 13px;
  }

  .more {
    cursor: pointer;
  }
</style>
